/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowTypeEnum } from './ShowTypeEnum';
import {
    ShowTypeEnumFromJSON,
    ShowTypeEnumFromJSONTyped,
    ShowTypeEnumToJSON,
    ShowTypeEnumToJSONTyped,
} from './ShowTypeEnum';
import type { Status02dEnum } from './Status02dEnum';
import {
    Status02dEnumFromJSON,
    Status02dEnumFromJSONTyped,
    Status02dEnumToJSON,
    Status02dEnumToJSONTyped,
} from './Status02dEnum';

/**
 * Lightweight serializer for show lists.
 * @export
 * @interface ShowList
 */
export interface ShowList {
    /**
     * 
     * @type {string}
     * @memberof ShowList
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ShowList
     */
    title: string;
    /**
     * 
     * @type {ShowTypeEnum}
     * @memberof ShowList
     */
    showType?: ShowTypeEnum;
    /**
     * 
     * @type {Status02dEnum}
     * @memberof ShowList
     */
    status?: Status02dEnum;
    /**
     * Show date - null for tentative shows until confirmed
     * @type {Date}
     * @memberof ShowList
     */
    showDate?: Date | null;
    /**
     * Preferred show time - null for tentative shows
     * @type {string}
     * @memberof ShowList
     */
    showTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowList
     */
    readonly venue: string;
    /**
     * Team that created/manages this show
     * @type {number}
     * @memberof ShowList
     */
    team?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShowList
     */
    readonly teamName: string;
    /**
     * 
     * @type {string}
     * @memberof ShowList
     */
    readonly performerCount: string;
    /**
     * Actual attendance count
     * @type {number}
     * @memberof ShowList
     */
    attendance?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShowList
     */
    readonly totalRevenue: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowList
     */
    isSettled?: boolean;
}



/**
 * Check if a given object implements the ShowList interface.
 */
export function instanceOfShowList(value: object): value is ShowList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('venue' in value) || value['venue'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('performerCount' in value) || value['performerCount'] === undefined) return false;
    if (!('totalRevenue' in value) || value['totalRevenue'] === undefined) return false;
    return true;
}

export function ShowListFromJSON(json: any): ShowList {
    return ShowListFromJSONTyped(json, false);
}

export function ShowListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'showType': json['show_type'] == null ? undefined : ShowTypeEnumFromJSON(json['show_type']),
        'status': json['status'] == null ? undefined : Status02dEnumFromJSON(json['status']),
        'showDate': json['show_date'] == null ? undefined : (new Date(json['show_date'])),
        'showTime': json['show_time'] == null ? undefined : json['show_time'],
        'venue': json['venue'],
        'team': json['team'] == null ? undefined : json['team'],
        'teamName': json['team_name'],
        'performerCount': json['performer_count'],
        'attendance': json['attendance'] == null ? undefined : json['attendance'],
        'totalRevenue': json['total_revenue'],
        'isSettled': json['is_settled'] == null ? undefined : json['is_settled'],
    };
}

  export function ShowListToJSON(json: any): ShowList {
      return ShowListToJSONTyped(json, false);
  }

  export function ShowListToJSONTyped(value?: Omit<ShowList, 'id'|'venue'|'team_name'|'performer_count'|'total_revenue'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'show_type': ShowTypeEnumToJSON(value['showType']),
        'status': Status02dEnumToJSON(value['status']),
        'show_date': value['showDate'] == null ? undefined : ((value['showDate'] as any).toISOString().substring(0,10)),
        'show_time': value['showTime'],
        'team': value['team'],
        'attendance': value['attendance'],
        'is_settled': value['isSettled'],
    };
}

